// print-ticket.component.ts

import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OrderDataService } from '@app/shared/services/order-data.service';

import jsPDF from 'jspdf';

@Component({
  selector: 'app-print-ticket',
  templateUrl: './print-ticket.component.html',
  styleUrls: ['./print-ticket.component.css']
})
export class PrintTicketComponent implements OnInit {
  orderList: any[] = [];
  filteredOrderList: any[] = [];
  paginatedOrderList: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;

  visiblePageRange: number[] = [];  // To store the visible pages
  searchText: string = '';
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' or 'desc'

  constructor(private OrderDataService: OrderDataService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getticketOrders();
  }

  getticketOrders() {
    this.OrderDataService.getAllUnsavedOrders().subscribe(
      (res: any) => {
        this.orderList = res.reverse();
        this.applyFilters();
        this.cdr.detectChanges(); // Trigger change detection
                console.log('this is orderlist',this.orderList);

      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  applyFilters() {
    this.filteredOrderList = this.orderList.filter(order =>
      order.ticketno.toLowerCase().includes(this.searchText.toLowerCase()) ||
      order.refNo.toLowerCase().includes(this.searchText.toLowerCase()) ||
      order.jobName.toLowerCase().includes(this.searchText.toLowerCase()) ||
      order.clientName.toLowerCase().includes(this.searchText.toLowerCase())
    );

    if (this.sortColumn) {
      this.filteredOrderList.sort((a, b) => {
        const valueA = a[this.sortColumn];
        const valueB = b[this.sortColumn];

        if (typeof valueA === 'string') {
          return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        } else if (typeof valueA === 'number') {
          return this.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
        }
        return 0;
      });
    }

    this.paginate();
  }

  sortByColumn(column: string) {
    this.sortDirection = (this.sortColumn === column && this.sortDirection === 'asc') ? 'desc' : 'asc';
    this.sortColumn = column;
    this.applyFilters();
  }


//for 1 only
  onSearch() {
    this.currentPage = 1;  // Initially start at page 1
    this.applyFilters();
    this.updatePageRange();
  }
  
  paginate() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedOrderList = this.filteredOrderList.slice(start, end);
  }
  
  onPageChange(page: number) {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
      this.paginate();
      this.updatePageRange();
    }
  }
  
  // Update visible page range based on the current page
  updatePageRange() {
    const totalPages = this.getTotalPages();
    
    // Show only the current page (1 page at a time)
    this.visiblePageRange = [this.currentPage];  // Show only the current page
  }
  
  calculateRangeStart() {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }
  
  calculateRangeEnd() {
    return Math.min(this.currentPage * this.itemsPerPage, this.filteredOrderList.length);
  }
  
  getTotalPages() {
    return Math.ceil(this.filteredOrderList.length / this.itemsPerPage);
  }
  
  getNumberRange(count: number) {
    return Array.from({ length: count }, (_, i) => i + 1);
  }


  deleteSelectedEntries() {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    const selectedIds = [];
    
    checkboxes.forEach((checkbox) => {
      if ((checkbox as HTMLInputElement).checked) {
        selectedIds.push((checkbox as HTMLInputElement).dataset.id); // Assuming dataset.id is used for ID
      }
    });

    if (selectedIds.length > 0) {
      this.OrderDataService.deleteAllUnsavedOrder(selectedIds).subscribe(
        (response) => {
          console.log('Entries deleted successfully:', response);
          // Optionally update your client list after deletion
          this.getticketOrders(); // Example method to fetch clients again
        },
        (error) => {
          console.error('Error deleting entries:', error);
          // Handle error in UI or show error message
        }
      );
    } else {
      console.log('No entries selected for deletion');
      // Handle case where no entries are selected
    }
  }

  selectAllChanged(event: Event) {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    checkboxes.forEach((checkbox) => {
      (checkbox as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
    });
  }

  print(order: any) {
    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.width;
    const topMargin = 2;
    const sideMargin = 10;
    doc.setFont('helvetica');
    const adjustedTop = topMargin + 8;
    const adjustedLeft = sideMargin + 10;
    doc.setFont('helvetica', 'bold');
    const ticketText = 'LEXIPACK GHANA LIMITED';
    const companyName = order.clientName || '';
    const companyJob = `${order.jobName || ''} (${order.jobType || ''})`;
    const textWidth = doc.getTextWidth(ticketText);
    const textX = (pageWidth - textWidth) / 2;
    doc.setFontSize(13);
    doc.text(ticketText, textX, adjustedTop + 2);
    doc.text(companyName, adjustedLeft, adjustedTop + 10);
    doc.text(companyJob, adjustedLeft, adjustedTop + 16);
    doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal'); // Set font back to normal

    // Render client and job details
    const PoNo = `Po No: ${order.poNo}`;;
    doc.text(PoNo, adjustedLeft - 8, adjustedTop + 23);
    const originalDate = new Date(order.created);
    const formattedDate = originalDate.toISOString().split('T')[0];

    const formattedDateString = `Date: ${formattedDate}`;
    doc.text(formattedDateString, adjustedLeft + 60, adjustedTop + 23);
    // Get current time
    const currentDate = new Date();
    const currentTime = currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const time = `Time: ${currentTime}`;  // Update the time field with current time
    doc.text(time, adjustedLeft + 95, adjustedTop + 23);

    // Set font style to bold
    doc.setFontSize(13); // Change the number to your desired font size
    doc.setFont('helvetica', 'bold');
    const Challan_No = `Ticket No: ${order.ticketno}`;
    doc.text(Challan_No, adjustedLeft + 140, adjustedTop + 10);
    // Assuming you have initialized doc, adjustedLeft, adjustedTop, and order.refNo appropriately
    doc.setFontSize(11); // Set to the default or desired font size for Ref No
    // Define the clientDetails string
    const clientDetails = `Ref No: ${order.refNo}`;

    // Set font style to bold
    doc.setFont('helvetica', 'bold');

    // Render the text with bold font
    doc.text(clientDetails, adjustedLeft - 8, adjustedTop + 32);



    const Serial = `FolderNo: ${order.jssfolderno}`;
    doc.text(Serial, adjustedLeft + 60, adjustedTop + 32);
    // Reset font style to normal (if needed for subsequent text)
    doc.setFont('helvetica', 'normal');
    const Barcode = `Barcode: ${order.barcode}`;
    doc.text(Barcode, adjustedLeft + 140, adjustedTop + 32);
    // const gstDetails = `JobName: ${order.jobName}`;
    // doc.text(gstDetails, adjustedLeft - 8, adjustedTop + 36);
    const Total_CMT = `JobType: ${order.jobType}`;
    doc.text(Total_CMT, adjustedLeft - 8, adjustedTop + 40);
 
    const ddDate = new Date(order.date1);
    const formattedddDate = ddDate.toISOString().split('T')[0];

    const formattedDDDateString = `Delivey Date: ${formattedddDate}`;
    doc.text(formattedDDDateString, adjustedLeft + 140, adjustedTop + 40);
    // const deliveyDate = `Delivey Date: ${order.date1}`;
    // doc.text(deliveyDate, adjustedLeft + 140, adjustedTop + 40);
    const status = `Status: New Order`;
    doc.text(status, adjustedLeft + 140, adjustedTop + 45);
    
    // const status = `Status: ${order.newOrder}`;
    // doc.text(status, adjustedLeft + 140, adjustedTop + 45);
    // const driverDetails = `Pouch / Pcs : ${order.pouch}`;
    // doc.text(driverDetails, adjustedLeft + 60, adjustedTop + 44);
    const gradeQtyDetails = `Quantity:-`;
    doc.text(gradeQtyDetails, adjustedLeft - 8, adjustedTop + 50);
    // const Qty = `Kgs: ${order.orderKgs}`;
    const Qty = `Kgs: ${parseFloat(order.orderKgs).toFixed(2)}`;
    doc.text(Qty, adjustedLeft + 20, adjustedTop + 50);
    // const TM_No = `PCs: ${order.pouch || order.orderPcs} `;
    const TM_No = `PCs: ${parseFloat(order.pouch || order.orderPcs).toFixed(2)}`;
    doc.text(TM_No, adjustedLeft + 20, adjustedTop + 55);
    // const Time_Out = `Cylinder Location: ${order.location}`;
    // doc.text(Time_Out, adjustedLeft + 96, adjustedTop + 49);
    // const Time_In = `Remarks: ${order.remark}`;
    // doc.text(Time_In, adjustedLeft + 90, adjustedTop + 55);

    const remarksText = `Remarks: ${order.remark}`;
    const maxLineWidth = pageWidth - adjustedLeft - 90; // Define max width for the text
    
    // Split the remark text into lines that fit within the allowed width
    const remarksLines = doc.splitTextToSize(remarksText, maxLineWidth);
    
    // Start drawing the text at the adjusted position
    let yPosition = adjustedTop + 52;
    
    // Draw each line of the remark text, adjusting the Y position for each new line
    remarksLines.forEach(line => {
      doc.text(line, adjustedLeft + 91, yPosition);
      yPosition += 6; // Adjust line spacing as needed
    });
    
    // Material Allocation section
    doc.line(sideMargin, adjustedTop + 59, pageWidth - sideMargin, adjustedTop + 59);
    doc.text(`RAW MATERIAL ALLOCATION`, adjustedLeft - 8, adjustedTop + 65);
    doc.text(`Processes`, adjustedLeft - 5, adjustedTop + 70);
    doc.text(`Material`, adjustedLeft + 50, adjustedTop + 70);
    doc.text(`Size (mm)`, adjustedLeft + 105, adjustedTop + 70);
    doc.text(`Thickness (µ)`, adjustedLeft + 129, adjustedTop + 70);
    doc.text(`Mat Req(kgs)`, adjustedLeft + 155, adjustedTop + 70);

    // Arrays for material allocation details
    const processes = [
      'Process1', 'Process2', 'Process3', 'Process4', 'Process5', 'Process6'
    ];

    // Assuming order object contains the data for each process
    const materials = [
      order.material1, order.material2, order.material3, order.material4, order.material5, order.material6
    ];

    const matSizes = [
      order.matSize1, order.matSize2, order.matSize3, order.matSize4, order.matSize5, order.matSize6
    ];

    const thickness = [
      order.thickness1, order.thickness2, order.thickness3, order.thickness4, order.thickness5, order.thickness6
    ];

    const matReqs = [
      order.matReq1, order.matReq2, order.matReq3, order.matReq4, order.matReq5, order.matReq6
    ];

    // Loop through and render each material allocation line
    for (let i = 0; i < processes.length; i++) {
      // Check if the process exists and is not NaN or '0'
      if (order[processes[i]] !== undefined && order[processes[i]] !== 'NaN' && order[processes[i]] !== '0') {
        const processLine = `${processes[i]}: ${order[processes[i]]}`;
        const materialLine = materials[i] !== 'NaN' ? materials[i] : '';
        const matSizeLine = matSizes[i] !== 'NaN' ? matSizes[i] : '';
        const thicknessLine = thickness[i] !== 'NaN' ? thickness[i] : '';
        const matReqLine = matReqs[i] !== 'NaN' ? matReqs[i] : '';

        doc.text(processLine, adjustedLeft - 7, adjustedTop + 80 + i * 6);
        doc.text(materialLine, adjustedLeft + 50, adjustedTop + 80 + i * 6);
        doc.text(matSizeLine, adjustedLeft + 105, adjustedTop + 80 + i * 6);
        doc.text(thicknessLine, adjustedLeft + 129, adjustedTop + 80 + i * 6);
        doc.text(matReqLine, adjustedLeft + 155, adjustedTop + 80 + i * 6);
      }
    }



    // Additional sections (Printing, Lamination, Slitting, Packing, Gluing and Sleeves, Bottom Design)
    // These sections should be filled according to your specific needs

    // Example section (Printing)
    doc.line(sideMargin, adjustedTop + 112, pageWidth - sideMargin, adjustedTop + 112);
    doc.text(`PRINTING`, adjustedLeft - 8, adjustedTop + 118);
    doc.text(`Cylinder Supplier: ${order.supplier || ''}`, adjustedLeft - 7, adjustedTop + 128);
    doc.text(`Cylinder ID: ${order.id || ''}`, adjustedLeft + 60, adjustedTop + 128);
    const Face_Length = `Face Length (mm): ${order.length || ''}`;
    doc.text(Face_Length, adjustedLeft + 115, adjustedTop + 128);
    doc.text(`Print type: ${order.printType || ''}`, adjustedLeft - 7, adjustedTop + 136);
    doc.text(`Print Direction: ${order.printDirection || ''}`, adjustedLeft + 60, adjustedTop + 136);
    const Circum = `Cylinder Circumference(mm): ${order.circumference || ''}`;
    doc.text(Circum, adjustedLeft + 60, adjustedTop + 146);
    const Location = `Cylinder Location:  ${order.location|| ''}`;
    doc.text(Location,  adjustedLeft + 130, adjustedTop + 146);

    // const CONS = `CONS:-`;
    // doc.text(CONS, adjustedLeft - 7, adjustedTop + 146);
    const Ink_GSM = `Ink GSM: ${order.std}`;
    doc.text(Ink_GSM, adjustedLeft - 7, adjustedTop + 146);
    // const Liquid_Inks = `Liquid Inks: ${order.liquid}`;
    // doc.text(Liquid_Inks, adjustedLeft + 60, adjustedTop + 146);
    const InkType = `InkType: ${order.inkType}`;
    doc.text(InkType, adjustedLeft + 115, adjustedTop + 156);
    // const No_of_Colors = `No of Colors: ${order.color}`;

    const No_of_Colors = `No of Colors: ${order.colorNumber}`;
    doc.text(No_of_Colors, adjustedLeft - 7, adjustedTop + 156);
    // const ActualPrint ='Actual printing material size:-';
    // doc.text(ActualPrint, adjustedLeft-7 ,adjustedTop + 165);
    const Color_Names = `Color Names:- ${order.colorNames}`;
    doc.text(Color_Names, adjustedLeft - 7, adjustedTop + 165);


    // Example section (Lamination)
    doc.line(sideMargin, adjustedTop + 170, pageWidth - sideMargin, adjustedTop + 170);
    doc.text(`LAMINATION`, adjustedLeft - 8, adjustedTop + 178);
    doc.text(`Lamination Type: ${order.
      LamType || ''}`, adjustedLeft - 8, adjustedTop + 185);
    doc.text(`Adhesive: ${order.nco || ''} x ${order.oh || ''}`, adjustedLeft + 60, adjustedTop + 185);
        doc.text(`Total GSM: ${order.totalGsm || ''}`, adjustedLeft + 140, adjustedTop + 185);


    // Example section (Slitting)
    doc.line(sideMargin, adjustedTop + 190, pageWidth - sideMargin, adjustedTop + 190);
    doc.text(`SLITTING`, adjustedLeft - 8, adjustedTop + 196);
    doc.text(`Core Type: ${order.coreType || ''}`, adjustedLeft - 8, adjustedTop + 203);
    doc.text(`Coil Width(Ups): ${order.coilWidth || ''}`, adjustedLeft - 8, adjustedTop + 210);
    doc.text(`Coil OD(mm): ${order.coilod || ''}`, adjustedLeft + 60, adjustedTop + 210);
    doc.text(`Final Direction: ${order.fdOption || ''}`, adjustedLeft + 115, adjustedTop + 210);
    doc.text(`Repeat Length(Ups): ${order.repeatLength || ''}`, adjustedLeft - 8, adjustedTop + 218);
    doc.text(`No. of Pcs/Kg: ${order.pouch || ''}`, adjustedLeft + 115, adjustedTop + 218);

    // Example section (Packing)
    doc.line(sideMargin, adjustedTop + 222, pageWidth - sideMargin, adjustedTop + 222);
    doc.text(`PACKING`, adjustedLeft - 8, adjustedTop + 228);
    doc.text(`Packing Type: ${order.packageType || ''}`, adjustedLeft - 8, adjustedTop + 235);

    // Example section (Gluing and Sleeves)
    doc.line(sideMargin, adjustedTop + 240, pageWidth - sideMargin, adjustedTop + 240);
    doc.text(`GLUING AND SLEEVES`, adjustedLeft - 8, adjustedTop + 244);
    doc.text(`Gluing: ${order.gluing || ''}`, adjustedLeft - 8, adjustedTop + 250);
    doc.text(`Roll Width: ${order.rollsWidth || ''}`, adjustedLeft + 60, adjustedTop + 250);
    doc.text(`Cutting Size: ${order.cutting || ''}`, adjustedLeft + 115, adjustedTop + 250);
    doc.text(`Prepared By: ${order.prepared || ''}`, adjustedLeft + 10, adjustedTop + 260);
    doc.text(`Approved by Sales: ${order.approved || ''}`, adjustedLeft + 115, adjustedTop + 260);
    doc.text(`Approved by QC: ${  ''}`, adjustedLeft + 10, adjustedTop + 270);
    doc.text(`Approved by Operations: ${ ''}`, adjustedLeft + 115, adjustedTop + 270);

    // Example bottom design section
    doc.setFont('helvetica', 'bold');
    doc.text(`---- Job Ticket Report ----`, adjustedLeft + 60, adjustedTop + 280);

    // Save the PDF
    const pdfOutput = doc.output('bloburl');

    // Open the PDF in a new tab for preview
    window.open(pdfOutput);
  }

  // onSearch() {
  //   this.currentPage = 1;
  //   this.applyFilters();
  // }

  // paginate() {
  //   const start = (this.currentPage - 1) * this.itemsPerPage;
  //   const end = start + this.itemsPerPage;
  //   this.paginatedOrderList = this.filteredOrderList.slice(start, end);
  // }

  // onPageChange(page: number) {
  //   if (page >= 1 && page <= this.getTotalPages()) {
  //     this.currentPage = page;
  //     this.paginate();
  //   }
  // }

  // calculateRangeStart() {
  //   return (this.currentPage - 1) * this.itemsPerPage + 1;
  // }

  // calculateRangeEnd() {
  //   return Math.min(this.currentPage * this.itemsPerPage, this.filteredOrderList.length);
  // }

  // getTotalPages() {
  //   return Math.ceil(this.filteredOrderList.length / this.itemsPerPage);
  // }

  // getNumberRange(count: number) {
  //   return Array.from({ length: count }, (_, i) => i + 1);
  // }







  // onSearch() {
  //   this.currentPage = 1;
  //   this.applyFilters();
  //   this.updatePageRange();
  // }
  
  // paginate() {
  //   const start = (this.currentPage - 1) * this.itemsPerPage;
  //   const end = start + this.itemsPerPage;
  //   this.paginatedOrderList = this.filteredOrderList.slice(start, end);
  // }
  
  // onPageChange(page: number) {
  //   if (page >= 1 && page <= this.getTotalPages()) {
  //     this.currentPage = page;
  //     this.paginate();
  //     this.updatePageRange();
  //   }
  // }
  
  // // Update visible page range based on the current page
  // updatePageRange() {
  //   const totalPages = this.getTotalPages();
  //   const maxVisiblePages = 3; // Show 3 pages at a time
    
  //   let startPage = Math.max(1, this.currentPage - 1); // Show the current page and 1 previous page
  //   let endPage = Math.min(totalPages, this.currentPage + 1); // Show the current page and 1 next page
    
  //   if (endPage - startPage < maxVisiblePages - 1) {
  //     if (startPage === 1) {
  //       endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  //     } else {
  //       startPage = Math.max(1, endPage - maxVisiblePages + 1);
  //     }
  //   }
  
  //   this.visiblePageRange = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  // }
  
  // calculateRangeStart() {
  //   return (this.currentPage - 1) * this.itemsPerPage + 1;
  // }
  
  // calculateRangeEnd() {
  //   return Math.min(this.currentPage * this.itemsPerPage, this.filteredOrderList.length);
  // }
  
  // getTotalPages() {
  //   return Math.ceil(this.filteredOrderList.length / this.itemsPerPage);
  // }
  
  // getNumberRange(count: number) {
  //   return Array.from({ length: count }, (_, i) => i + 1);
  // }


  //   print(order: any) {
  //     const doc = new jsPDF();
  // let statusText;
  // if (order.repeatedStatus === 'Existing Order') {
  //     statusText = `Status: ${order.repeatedStatus}`; // Print the status if it is an existing order
  // } else {
  //     statusText = 'Status: New Order'; // Indicate new order if the status is not existing
  // }
  
  // doc.text(statusText, adjustedLeft + 140, adjustedTop + 40);
  //     const pageWidth = doc.internal.pageSize.width;
  //     const topMargin = 2;
  //     const sideMargin = 10;
  //     doc.setFont('helvetica');
  //     const adjustedTop = topMargin + 8;
  //     const adjustedLeft = sideMargin + 10;
  //     doc.setFont('helvetica', 'bold');
  //     const ticketText = 'LEXIPACK GHANA LIMITED';
  //     const companyName = order.clientName || '';
  //     const companyJob = `${order.jobName || ''} (${order.jobType || ''})`;
  //     const textWidth = doc.getTextWidth(ticketText);
  //     const textX = (pageWidth - textWidth) / 2;
  //     doc.setFontSize(13);
  //     doc.text(ticketText, textX, adjustedTop + 2);
  //     doc.text(companyName, adjustedLeft, adjustedTop + 10);
  //     doc.text(companyJob, adjustedLeft, adjustedTop + 16);
  //     doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
  //     doc.setFontSize(11);
  //     doc.setFont('helvetica', 'normal'); // Set font back to normal

  //     const lines = [
  //         `Po No: ${order.poNo || ''}`,
  //         `Ticket No: ${order.ticketno || ''}`,
  //         `Ref No: ${order.refNo || ''}`,
  //         `FolderNo: ${order.jssfolderno || ''}`,
  //         `JobName: ${order.jobName || ''}`,
  //         `JobType: ${order.jobType || ''}`,
  //         `Pouch / Pcs : ${order.pouch || ''}`,
  //         `Kgs: ${order.orderKgs || ''}`,
  //         `Cylinder Location: ${order.location || ''}`,
  //         `Remarks: ${order.remark || ''}`
  //     ];

  //     let formattedDateString = '';
  //     if (order.date1) {
  //         const originalDate = new Date(order.date1);
  //         const formattedDate = originalDate.toISOString().split('T')[0];
  //         formattedDateString = `Date: ${formattedDate}`;
  //     }

  //     if (formattedDateString) {
  //         lines.push(formattedDateString);
  //     }

  //     // Material Allocation section
  //     doc.line(sideMargin, adjustedTop + 23, pageWidth - sideMargin, adjustedTop + 23);

  //     doc.text(`RAW MATERIAL ALLOCATION`, adjustedLeft - 8, adjustedTop + 30);
  //     doc.text(`Processes`, adjustedLeft + 11, adjustedTop + 35);
  //     doc.text(`Material`, adjustedLeft + 65, adjustedTop + 35);
  //     doc.text(`Mat Req`, adjustedLeft + 105, adjustedTop + 35);
  //     doc.text(`Mat Size`, adjustedLeft + 145, adjustedTop + 35);

  //     const processes = [
  //         order.Process1, order.Process2, order.Process3, order.Process4, order.Process5, order.Process6
  //     ];

  //     const materials = [
  //         order.material1, order.material2, order.material3, order.material4, order.material5, order.material6
  //     ];

  //     const matReqs = [
  //         order.thickness1, order.thickness2, order.thickness3, order.thickness4, order.thickness5, order.thickness6
  //     ];

  //     const matSizes = [
  //         order.matSize1, order.matSize2, order.matSize3, order.matSize4, order.matSize5, order.matSize6
  //     ];

  //     for (let i = 0; i < processes.length; i++) {
  //         if (processes[i] !== 'NaN' && processes[i] !== 0) {
  //             const processLine = `Process${i + 1}: ${processes[i]}`;
  //             const materialLine = materials[i] !== 'NaN' ? materials[i] : '';
  //             const matReqLine = matReqs[i] !== 'NaN'? matReqs[i] : '';
  //             const matSizeLine = matSizes[i] !== 'NaN' ? matSizes[i] : '';

  //             doc.text(processLine, adjustedLeft - 7, adjustedTop + 43 + i * 6);
  //             doc.text(materialLine, adjustedLeft + 50, adjustedTop + 43 + i * 6);
  //             doc.text(matReqLine, adjustedLeft + 110, adjustedTop + 43 + i * 6);
  //             doc.text(matSizeLine, adjustedLeft + 145, adjustedTop + 43 + i * 6);
  //         }
  //     }

  //     // Continue with the rest of your document content...

  //     // Save the PDF
  //     const pdfOutput = doc.output('bloburl');

  //     // Open the PDF in a new tab for preview
  //     window.open(pdfOutput);
  // }


  //     print(order: any)  {
  //     const doc = new jsPDF();

  //     const pageWidth = doc.internal.pageSize.width;
  //     const pageHeight = doc.internal.pageSize.height;
  //     const topMargin = 2;
  //     const bottomMargin = 10;
  //     const sideMargin = 10;
  //     doc.setFont('helvetica');
  //     const adjustedTop = topMargin + 8;
  //     const adjustedLeft = sideMargin + 10;
  //     doc.setFont('helvetica', 'bold');
  //     const ticketText = 'LEXIPACK GHANA LIMITED';
  //     const companyName =  order.clientName;
  //     const companyJob =  `${order.jobName} (${order.jobType})`;
  //     const textWidth = doc.getTextWidth(ticketText);
  //     const textX = (pageWidth - textWidth) / 2;
  //     doc.setFontSize(13);
  //     doc.text(ticketText, textX, adjustedTop + 2);
  //     doc.text(companyName, adjustedLeft, adjustedTop + 10);
  //     doc.text(companyJob, adjustedLeft , adjustedTop + 16);
  //     doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
  //     doc.setFontSize(11);
  //     doc.setFont('helvetica', 'normal'); // Set font back to normal

  //     const PoNo = `Po No: ${order.poNo}`;;
  //     doc.text(PoNo, adjustedLeft - 8, adjustedTop + 23);
  //     // Use a different variable name, e.g., 'formattedDateString'
  // const originalDate = new Date(order.date1);
  // const formattedDate = originalDate.toISOString().split('T')[0];

  // const formattedDateString = `Date: ${formattedDate}`;
  // doc.text(formattedDateString, adjustedLeft + 60, adjustedTop + 23);


  //     // const Date = `Date: ${order.date1}`;
  //     // doc.text(Date, adjustedLeft + 60, adjustedTop + 23);
  //     const Challan_No = `Ticket No: ${order.ticketno}`;
  //     doc.text(Challan_No,adjustedLeft + 140 , adjustedTop + 23);
  //     const clientDetails = `Ref No: ${order.refNo}`;
  //     doc.text(clientDetails, adjustedLeft - 8, adjustedTop + 30);
  //     const Serial = `FolderNo: ${order.jssfolderno}`;
  //     doc.text(Serial, adjustedLeft + 140, adjustedTop + 30);

  //     const gstDetails = `JobName: ${order.jobName}`;
  //     doc.text(gstDetails, adjustedLeft - 8, adjustedTop + 36);
  //     const Total_CMT = `JobType: ${order.jobType}`;
  //     doc.text(Total_CMT, adjustedLeft-8, adjustedTop + 44);
  //     const driverDetails = `Pouch / Pcs : ${order.pouch}`;
  //     doc.text(driverDetails, adjustedLeft+ 60, adjustedTop + 44);
  //     const gradeQtyDetails = `Quantity:-`;
  //     doc.text(gradeQtyDetails, adjustedLeft - 8, adjustedTop +50);
  //     const Qty = `Kgs: ${order.orderKgs}`;
  //     doc.text(Qty, adjustedLeft + 20, adjustedTop + 50);
  //     const TM_No = `PCs No.: `;
  //     doc.text(TM_No, adjustedLeft +20, adjustedTop + 55);
  //     const Time_Out = `Cylinder Location: ${order.location}`;
  //     doc.text(Time_Out, adjustedLeft + 96,adjustedTop + 50);
  //     const Time_In = `Remarks: ${order.remark}`;
  //     doc.text(Time_In,adjustedLeft + 96, adjustedTop + 55);
  //     doc.line(sideMargin, adjustedTop + 59, pageWidth - sideMargin, adjustedTop + 59);
  //     doc.text(`RAW MATERIAL ALLOCATION`, adjustedLeft - 8, adjustedTop + 65);
  //     doc.text(`Processes`, adjustedLeft + 11, adjustedTop + 70);
  //     doc.text(`Material`, adjustedLeft + 65, adjustedTop + 70);
  //     doc.text(`Mat Req`, adjustedLeft +105, adjustedTop + 70);
  //     doc.text(`Mat Size`, adjustedLeft + 145, adjustedTop + 70);

  //     // const GST_No = `GST No.: `;
  //     // doc.text(GST_No, adjustedLeft + 120, adjustedTop + 80);
  //     const Process1	= `Process1: ${order.Process1 || order.Null}`;
  //     doc.text(Process1	, adjustedLeft-7, adjustedTop + 78);
  //     const Process2= `Process2: ${order.Process2 || order.Null}`;
  //     doc.text(Process2 , adjustedLeft-7, adjustedTop + 84);
  //     const Process3 = `Process3: ${order.Process3 || order.Null}`;
  //     doc.text(Process3, adjustedLeft-7, adjustedTop + 90);
  //     const Process4 = `Process4: ${order.Process4 || order.Null}`;
  //     doc.text(Process4, adjustedLeft-7, adjustedTop + 96);
  //     const Process5 = `Process5: ${order.Process5 || order.Null}`;
  //     doc.text(Process5, adjustedLeft-7, adjustedTop + 102);
  //     const Process6 = `Process6: ${order.Process6 || order.Null}`;
  //     doc.text(Process6, adjustedLeft-7, adjustedTop + 108);

  //   // Material
  //     const Material1	= `${order.material1 || order.Null}`;
  //     doc.text(Material1	, adjustedLeft +50, adjustedTop + 78);
  //     const Material2= `${order.material2 || order.Null}`;
  //     doc.text(Material2 , adjustedLeft+50, adjustedTop + 84);
  //     const Material3 = `${order.material3 || order.Null}`;
  //     doc.text(Material3, adjustedLeft+50, adjustedTop + 90);
  //     const Material4 = `${order.material4 || order.Null}`;
  //     doc.text(Material4, adjustedLeft+50, adjustedTop + 96);
  //     const Material5 = `${order.material5 || order.Null}`;
  //     doc.text(Material5, adjustedLeft+50, adjustedTop + 102);
  //     const Material6 = `${order.material6 || order.Null}`;
  //     doc.text(Material6, adjustedLeft+50, adjustedTop + 108);

  //     const MatReq1	= `${order.thickness1}`;
  //     doc.text(MatReq1	, adjustedLeft+110, adjustedTop + 78);
  //     const MatReq2= `${order.thickness2 || order.NAN}`;
  //     doc.text(MatReq2 , adjustedLeft+110, adjustedTop + 84);
  //     const MatReq3 = `${order.thickness3 || order.Null}`;
  //     doc.text(MatReq3, adjustedLeft+110, adjustedTop + 90);
  //     const MatReq4 = `${order.thickness4 || order.Null}`;
  //     doc.text(MatReq4, adjustedLeft+110, adjustedTop + 96);
  //     const MatReq5 = `${order.thickness5 || order.Null}`;
  //     doc.text(MatReq5, adjustedLeft+110, adjustedTop + 102);
  //     const MatReq6 = `${order.thickness6 || order.Null}`;
  //     doc.text(MatReq6, adjustedLeft+110, adjustedTop + 108);

  //     const MatSize1	= `${order.matSize1}`;
  //     doc.text(MatSize1	, adjustedLeft+145, adjustedTop + 78);
  //     const MatSize2= `${order.matSize2 || order.Null}`;
  //     doc.text(MatSize2 , adjustedLeft+145, adjustedTop + 84);
  //     const MatSize3 = `${order.matSize3 || order.Null}`;
  //     doc.text(MatSize3, adjustedLeft+145, adjustedTop + 90);
  //     const MatSize4 = `${order.matSize4 || order.Null}`;
  //     doc.text(MatSize4, adjustedLeft+145, adjustedTop + 96);
  //     const MatSize5 = `${order.matSize5 || order.Null}`;
  //     doc.text(MatSize5, adjustedLeft+145, adjustedTop + 102);
  //     const MatSize6 = `${order.matSize6 || order.Null}`;
  //     doc.text(MatSize6, adjustedLeft+145, adjustedTop + 108);


  //     doc.line(sideMargin, adjustedTop +112, pageWidth - sideMargin, adjustedTop +112);
  //     doc.text(`PRINTING`, adjustedLeft - 8, adjustedTop + 118);
  //     const Print_type	= `Print type: ${order.printType}`;
  //     doc.text(Print_type	, adjustedLeft-7, adjustedTop + 125);
  //     const Print_Direction	= `Print Direction: ${order.printDir}`;
  //     doc.text(Print_Direction	, adjustedLeft+60, adjustedTop + 125);
  //     const CONS = `CONS:-`;
  //     doc.text(CONS, adjustedLeft - 7 ,adjustedTop + 139);
  //     const Ink_GSM = `Ink GSM: ${order.lInkgsm}`;
  //     doc.text(Ink_GSM, adjustedLeft+10 ,adjustedTop + 139);
  //     const Liquid_Inks= `Liquid Inks: ${order.liquid}`;
  //     doc.text(Liquid_Inks, adjustedLeft+60 ,adjustedTop + 139);
  //     const InkType= `InkType: ${order.inkType}`;
  //     doc.text(InkType, adjustedLeft+115 ,adjustedTop + 139);
  //     const No_of_Colors = `No of Colors: ${order.color}`;
  //     doc.text(No_of_Colors, adjustedLeft+10 ,adjustedTop + 149);
  //     const Face_Length = `Face Length:`;
  //     doc.text(Face_Length, adjustedLeft+60 ,adjustedTop + 149);
  //     const Circum= `Circum:`;
  //     doc.text(Circum, adjustedLeft+115 ,adjustedTop + 149);

  //     doc.line(sideMargin, adjustedTop +154, pageWidth - sideMargin, adjustedTop +154);
  //     doc.text(`LAMINATION`, adjustedLeft - 8, adjustedTop + 160);
  //     const TYPE1 = `TYPE: `;
  //     doc.text(TYPE1, adjustedLeft+10 ,adjustedTop + 169);
  //     const ADHESIVE= `ADHESIVE:`;
  //     doc.text(ADHESIVE, adjustedLeft+60  ,adjustedTop + 169);

  //     doc.line(sideMargin, adjustedTop +173, pageWidth - sideMargin, adjustedTop +173);
  //     doc.text(`SLITTING`, adjustedLeft - 8, adjustedTop + 179);

  //     const Coil_Width = `Coil Width: ${order.coilWidth}`;
  //     doc.text(Coil_Width, adjustedLeft+10 ,adjustedTop + 185);
  //     const Coil_OD= `Coil OD : ${order.coilod}`;
  //     doc.text(Coil_OD, adjustedLeft+60 ,adjustedTop + 185);
  //     const Final_Direction= `Final Direction: ${order.direction}`;
  //     doc.text(Final_Direction, adjustedLeft+115 ,adjustedTop + 185);


  //     doc.line(sideMargin, adjustedTop +190, pageWidth - sideMargin, adjustedTop +190);
  //     doc.text(`PACKING`, adjustedLeft - 8, adjustedTop + 200);

  //     const TYPE2 = `TYPE: `;
  //     doc.text(TYPE2, adjustedLeft+10 ,adjustedTop + 205);

  //     doc.line(sideMargin, adjustedTop +210, pageWidth - sideMargin, adjustedTop +210);
  //     doc.text(`GLUING AND SLEEVES`, adjustedLeft - 8, adjustedTop + 218);
  //     //doc.setFont('helvetica', 'bold');

  //     const Gluing = `Gluing: ${order.gluing}`;
  //     doc.text(Gluing, adjustedLeft+10 ,adjustedTop + 228);

  //     // doc.setFont('helvetica', 'bold');

  //     const Roll_Width= `Roll Width : ${order.rollsWidth}`;
  //     doc.text(Roll_Width, adjustedLeft+60 ,adjustedTop + 228);
  //     // doc.setFont('helvetica', 'bold');

  //     const CuttingSize = `Cutting Size: ${order.cutting}`;
  //     doc.text(CuttingSize, adjustedLeft+115 ,adjustedTop +228);
  //     // doc.setFont('helvetica', 'bold');

  //     const Prepared_By= `Prepared By: ${order.prepared}`;
  //     doc.text(Prepared_By, adjustedLeft+10 ,adjustedTop +240);

  //     // doc.setFont('helvetica', 'bold');
  //     const Approv_by= `Approv by: ${order.approved}`;
  //     doc.text(Approv_by, adjustedLeft+115 ,adjustedTop +240);

  // //buttom design taken
  // doc.setFont('helvetica', 'bold');
  //     const Job_Ticket= `---- Job Ticket Report ----`;
  //     doc.text(Job_Ticket, adjustedLeft+60 ,adjustedTop +280);



  //     // Save the PDF
  //     const pdfOutput = doc.output('bloburl');

  //     // Open the PDF in a new tab for preview
  //     window.open(pdfOutput);
  //   }
}
